import { Message } from 'element-ui';
let messageDom = null
const resetMessage = (options) => {
    if (messageDom) messageDom.close() // 判断弹窗是否已存在,若存在则关闭
    messageDom = Message(options)
}
const typeArr = ['success', 'error', 'warning', 'info']
typeArr.forEach(type => {
    resetMessage[type] = options => {
        if (typeof options === 'string') {
            options = { message: options }
                // 默认配置
            options.duration = 5000;
            options.showClose = true;
        }
        options.type = type
        return resetMessage(options)
    }
})
const message = resetMessage
export default message